export default {
    comingSoon: 'Страница еще в разработке',
};
